export const getIsTestNetwork = (): boolean => {
  return process.env.NODE_ENV !== 'production'
}
